module.exports = __webpack_public_path__ + "static/media/sevaDiwas.67814a98.JPG";